import {Box, Grid} from '@mui/material';
import {AppButton} from 'components/buttons';
import {AppControlledAutoComplete, AppStatusSelect} from 'components/form';
import {AppInfoText} from 'components/typographies';
import {encrypt, SelectOptionsType} from 'global';
import {useBoardRedux, useGetAllBoardForms} from 'hooks/board';
import {useAlert} from 'hooks/useAlert';
import {BoardFormGenerateRequest, defaultBoardForm} from 'models/board/boardDynamicForm.model';
import {useEffect, useMemo, useState} from 'react';
import {useForm} from 'react-hook-form';
import {useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';
import {sessionSelector} from 'store/auth/sessionSlice';

export const BoardDynamicFrom = () => {
    const {boardId} = useParams();

    const {selectedBoard} = useBoardRedux();
    // const {getAllItemStatuses, getAllStatusesLoading, getAllStatusessResponse} = useGetAllItemStatusesByBoardId();
    const {getAllBoardForms, getAllBoardFormsLoading, getAllBoardFormsResponse} = useGetAllBoardForms();
    const [divElementId, setDiveElementId] = useState('Please select a form');
    // const {getAllSprints, getAllSprintsLoading, getAllSprintsResponse} = useGetAllSprints();
    const {invokeSuccessMessage} = useAlert();
    const {control, handleSubmit, watch} = useForm<BoardFormGenerateRequest>({
        defaultValues: defaultBoardForm,
    });
    const {tenantId} = useSelector(sessionSelector);

    const watchSelectedForm = watch('SelectedForm');
    useEffect(() => {
        if (watchSelectedForm && selectedBoard) {
            setDiveElementId(`${selectedBoard.slug}-${watchSelectedForm.label.toLowerCase().replace(/\s+/g, '-')}`);
        }
    }, [watchSelectedForm, selectedBoard]);

    useEffect(() => {
        if (selectedBoard) {
            getAllBoardForms({
                variables: {
                    where: {
                        boardId: {eq: selectedBoard.id},
                    },
                },
            });
        }
    }, [selectedBoard]);

    const boardFormOptions = useMemo((): SelectOptionsType[] => {
        if (getAllBoardFormsResponse && !getAllBoardFormsLoading) {
            return getAllBoardFormsResponse.map(boardForm => ({
                label: boardForm.title,
                value: boardForm.id,
            }));
        }
        return [];
    }, [getAllBoardFormsLoading, getAllBoardFormsResponse]);
    const onSubmitHandler = (data: BoardFormGenerateRequest) => {
        const scriptData = {
            // boardId: selectedBoard?.id,
            itemStatusId: data.SelectedStatus.value,
            formId: data.SelectedForm.value,
            baseUrl: window.location.pathname,
            sprintId: data.SelectedSprint?.value ?? 'null',
            apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
            tenantId: tenantId,
            elementId: divElementId,
        };
        const encryptedData = encrypt(
            JSON.stringify(scriptData),
            process.env.REACT_APP_DYNAMIC_FORM_DATA_ENCRYTION_KEY?.toString() ?? '',
        );
        //copy to clipboard code
        navigator.clipboard.writeText(`<script
      src="${process.env.REACT_APP_API_BASE_URL}/js/dynamic-from.js"
      data-v1="${encryptedData}"
         ></script>`);
        invokeSuccessMessage('Script copied to clipboard');
    };

    return (
        <Box
            height={'calc(100vh - 180px)'}
            overflow={'auto'}
            component={'form'}
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit(onSubmitHandler)}
        >
            <Grid container spacing={2}>
                <Grid item xs={12} mt={1}>
                    <AppInfoText>
                        Id for the element where the form will be rendered is "<strong>{divElementId}</strong>"
                    </AppInfoText>
                </Grid>
                <Grid item xs={12}>
                    <AppStatusSelect
                        label="Statuses"
                        control={control}
                        name="SelectedStatus"
                        required="Status field is required"
                        boardSlug={boardId}
                    />
                </Grid>
                <Grid item xs={12}>
                    <AppControlledAutoComplete
                        control={control}
                        loading={getAllBoardFormsLoading}
                        label="Forms"
                        options={boardFormOptions}
                        name="SelectedForm"
                        required="Form field is required"
                    />
                </Grid>
            </Grid>
            <Box mt={2} display="flex" justifyContent="flex-end">
                <AppButton type="submit">Copy Script</AppButton>
            </Box>
        </Box>
    );
};

export default BoardDynamicFrom;
